import { createContext, useContext, useEffect, useState } from "react";

export const STRINGS = {
  it: {
    seo: {
      title: "Dimore del Sole — Nuovi appartamenti in vendita a Bordighera (IM) | Riviera dei Fiori",
      description: "Bilocali, trilocali e attico in classe A con piscina e giardini a Bordighera, Riviera dei Fiori. Palazzina A in pronta consegna. Da € 250.000. Prenota una visita.",
    },
    nav: { progetto: "Il Progetto", appartamenti: "Appartamenti", galleria: "Galleria", contesto: "Il Contesto", contatti: "Contatti" },
    headerCta: "Prenota una visita",
    brochure: "Scarica la brochure",
    brochureModal: {
      title: "Scarica la brochure",
      subtitle: "Lascia i tuoi contatti e scarica subito la brochure completa con planimetrie e prezzi. Te la inviamo anche via email.",
      submit: "Scarica ora",
      success: "Grazie! Il download parte ora e ti abbiamo inviato la brochure anche via email.",
      leadNote: "Richiesta download brochure dal sito",
    },
    hero: {
      eyebrow: "Residenziale a Bordighera — Riviera dei Fiori",
      line1: "Abitare Bordighera,",
      line2: "tra mare e quiete",
      subtitle: "Nuovi appartamenti in classe A con piscina, giardini privati e box auto, nel verde di Bordighera.",
      subtitle2: "Palazzina A in pronta consegna.",
      ctaPrimary: "Richiedi informazioni",
      scroll: "Scorri",
      alt: "Vista aerea di Bordighera e della sua costa",
    },
    whatsapp: {
      label: "Scrivici su WhatsApp",
      msg: "Salve, vorrei informazioni sugli appartamenti Dimore del Sole a Bordighera.",
      call: "Chiama",
    },
    video: { label: "Il video", title: "La residenza vista dal drone" },
    manifesto: {
      label: "Perché Dimore del Sole",
      h2a: "Nuovi, in classe A, con giardini, terrazze e box: ",
      h2em: "il valore vero",
      h2b: " nella Riviera dei Fiori.",
      chapters: [
        { n: "01", t: "Nuovo e in classe A: zero lavori, bollette leggere", d: "Costruzione appena ultimata: nessuna ristrutturazione, nessuna sorpresa. Gres porcellanato, serramenti di alta gamma e impianto fotovoltaico condominiale: efficienza che senti ogni mese, in bolletta e nel comfort." },
        { n: "02", t: "Il fuori è tuo: giardini, terrazze e piscina", d: "Giardini privati fino a 300 mq, terrazze panoramiche e piscina condominiale immersa nel verde. A Bordighera si vive all'aperto dodici mesi l'anno, in uno dei climi più miti d'Italia." },
        { n: "03", t: "I primi 8 appartamenti in pronta consegna", d: "La Palazzina A è ultimata: otto appartamenti subito disponibili, senza attese di cantiere. Box privato con predisposizione per la ricarica elettrica e cantine, acquistabili separatamente." },
        { n: "04", t: "Un investimento che dura: la Riviera dei Fiori", d: "Nuova costruzione in una delle località più richieste della Liguria, a pochi minuti dal mare, dalla stazione e dalla Francia: un valore destinato a crescere nel tempo." },
      ],
    },
    apartments: {
      label: "Gli Appartamenti",
      h2a: "Soluzioni abitative pensate per ",
      h2em: "ogni esigenza",
      desc: "Bilocali, trilocali e attico con giardini privati o grandi terrazze, all'interno della Palazzina A appena ultimata e in pronta consegna.",
      rooms: "Locali",
      surface: "Superficie commerciale",
      outdoor: "Spazio esterno",
      price: "Prezzo",
      from: "da",
      plan: "Planimetria",
      view: "Vista",
      sqUnit: "mq",
      items: {
        bilocale: { nome: "Bilocale", esterno: "Balcone 11 mq" },
        "bilocale-cucina": { nome: "Bilocale + cucina", esterno: "Giardino 215 mq", localiLabel: "2 + cucina" },
        trilocale: { nome: "Trilocale", esterno: "Giardino 300 mq" },
        attico: { nome: "Attico", esterno: "Terrazza panoramica" },
      },
      extras: {
        label: "Acquistabili separatamente",
        boxTitle: "Box auto",
        boxDesc: "Privati, con predisposizione per la ricarica dei veicoli elettrici.",
        cantinaTitle: "Cantine",
        cantinaDesc: "Comodi spazi accessori, ideali come deposito o cantinetta.",
      },
      ctaTitle: "Vuoi vederli dal vivo? Ti accompagniamo noi.",
    },
    gallery: {
      label: "Galleria",
      h2a: "La qualità costruttiva, dalle fondamenta ",
      h2em: "alle finiture",
      captions: ["Facciate", "Zona notte", "Cucina e living", "La piscina", "La residenza dall'alto"],
    },
    location: {
      label: "Il Contesto",
      h2a: "Tra il mare, la natura ",
      h2em: "e i servizi",
      p: "Dimore del Sole sorge tra Via Mameli e Via Pasteur, a Bordighera: una posizione strategica e riservata, immersa nel verde a pochi minuti dal centro, dal lungomare e dalla Francia. A 100 metri il Piatti Tennis Center; il punto di partenza ideale per Sanremo, la Costa Azzurra e Montecarlo.",
      distLabel: "Distanze",
      distances: [["Lungomare Argentina", "2,5 km"], ["Stazione di Bordighera", "3 km"], ["Stazione di Ventimiglia", "6 km"], ["Sanremo", "12 km"], ["Montecarlo", "25 km"], ["Aeroporto di Nizza", "54 km"]],
      imgAlt: "La passeggiata del Lungomare Argentina a Bordighera",
    },
    contact: {
      label: "Prenota la tua visita",
      h2a: "Vieni a scoprire ",
      h2em: "Dimore del Sole",
      h2b: " di persona",
      p: "Compila il modulo per ricevere la brochure, le planimetrie e fissare un appuntamento. Sarai ricontattato entro 24 ore.",
      orari: "Su appuntamento, tutti i giorni",
      nome: "Nome", cognome: "Cognome", email: "Email", telefono: "Telefono",
      tipologia: "Tipologia di interesse",
      tipologie: ["Bilocale", "Bilocale + cucina", "Trilocale", "Attico", "Non so ancora"],
      messaggio: "Messaggio (facoltativo)",
      privacy: "Ho letto l'informativa privacy e acconsento al trattamento dei miei dati per essere ricontattato. *",
      privacyLink: "Leggi l'informativa",
      submit: "Invia la richiesta",
      sending: "Invio in corso…",
      success: "Richiesta inviata. Ti ricontatteremo entro 24 ore.",
    },
    footer: {
      tagline: "Residenziale a Bordighera",
      privacy: "Privacy Policy",
      cookie: "Cookie Policy",
      admin: "Area riservata",
      rights: "© 2026 Dimore del Sole — Bordighera (IM). Tutti i diritti riservati.",
      disclaimer: "Immagini e render a scopo puramente illustrativo. Foto di Bordighera: Wikimedia Commons (CC BY-SA).",
    },
    cookieBanner: {
      title: "Cookie",
      text: "Utilizziamo cookie tecnici e, con il tuo consenso, cookie di misurazione e pubblicità (Google) per capire l'efficacia delle nostre campagne.",
      short: "Usiamo cookie tecnici e, con il tuo consenso, di misurazione e pubblicità.",
      accept: "Accetta",
      necessary: "Solo necessari",
      more: "Cookie Policy",
    },
    policies: {
      privacy: {
        title: "Privacy Policy",
        body: [
          "Titolare del trattamento: Dimore del Sole — Via Goffredo Mameli 40, 18012 Bordighera (IM). Email: info@dimoredelsole.com.",
          "Dati trattati e finalità: i dati inseriti nel modulo di contatto (nome, cognome, email, telefono, tipologia di interesse, messaggio) sono trattati al solo fine di rispondere alla tua richiesta di informazioni e fissare un eventuale appuntamento.",
          "Base giuridica: il trattamento si fonda sul consenso espresso dall'interessato (art. 6, par. 1, lett. a del Regolamento UE 2016/679 — GDPR) e sull'esecuzione di misure precontrattuali richieste dall'interessato (art. 6, par. 1, lett. b).",
          "Modalità e destinatari: i dati sono trattati con strumenti elettronici e non vengono ceduti a terzi né utilizzati per finalità di marketing. Vi accedono esclusivamente il titolare e i fornitori tecnici del sito (hosting e servizio di invio email), in qualità di responsabili del trattamento.",
          "Conservazione: i dati sono conservati per il tempo strettamente necessario a gestire la richiesta e comunque non oltre 24 mesi dall'ultimo contatto.",
          "Diritti dell'interessato: ai sensi degli artt. 15-22 del GDPR puoi richiedere in qualsiasi momento l'accesso, la rettifica, la cancellazione, la limitazione e la portabilità dei dati, opporti al trattamento e revocare il consenso, scrivendo a info@dimoredelsole.com.",
          "Reclamo: hai inoltre il diritto di proporre reclamo all'autorità di controllo italiana, il Garante per la Protezione dei Dati Personali (www.garanteprivacy.it).",
        ],
      },
      cookie: {
        title: "Cookie Policy",
        body: [
          "Questo sito, in conformità al Regolamento UE 2016/679 (GDPR) e alla direttiva ePrivacy, utilizza cookie tecnici e strumenti di memorizzazione locale necessari al funzionamento — la preferenza della lingua (dds-lang) e la registrazione della tua scelta sui cookie (dds-cookie-consent) — per i quali non è richiesto il consenso preventivo.",
          "Con il tuo consenso utilizziamo inoltre Google Ads (gtag.js), servizio di misurazione e marketing di terze parti fornito da Google Ireland Ltd., per misurare l'efficacia delle nostre campagne pubblicitarie. Questi cookie sono attivati solo dopo aver cliccato \"Accetta\" nel banner (Google Consent Mode v2); scegliendo \"Solo necessari\" restano disattivati. Maggiori informazioni: policies.google.com/privacy.",
          "Puoi modificare o revocare la tua scelta in qualsiasi momento cancellando i cookie e i dati dei siti dalle impostazioni del tuo browser: al successivo accesso il banner ti verrà riproposto.",
        ],
      },
    },
  },
  fr: {
    seo: {
      title: "Dimore del Sole — Appartements neufs à vendre à Bordighera (Italie) | Riviera des Fleurs",
      description: "2 pièces, 3 pièces et attique en classe énergétique A avec piscine et jardins à Bordighera, Riviera italienne, à quelques minutes de la France. À partir de 250 000 €.",
    },
    nav: { progetto: "Le Projet", appartamenti: "Appartements", galleria: "Galerie", contesto: "L'Environnement", contatti: "Contact" },
    headerCta: "Réserver une visite",
    brochure: "Télécharger la brochure",
    brochureModal: {
      title: "Télécharger la brochure",
      subtitle: "Laissez vos coordonnées et téléchargez immédiatement la brochure complète avec plans et prix. Nous vous l'envoyons aussi par email.",
      submit: "Télécharger maintenant",
      success: "Merci ! Le téléchargement démarre et la brochure vous a aussi été envoyée par email.",
      leadNote: "Demande de téléchargement de la brochure depuis le site",
    },
    hero: {
      eyebrow: "Résidence à Bordighera — Riviera des Fleurs",
      line1: "Habiter Bordighera,",
      line2: "entre mer et quiétude",
      subtitle: "Appartements neufs en classe A avec piscine, jardins privés et garages, dans la verdure de Bordighera.",
      subtitle2: "Bâtiment A livrable immédiatement.",
      ctaPrimary: "Demander des informations",
      scroll: "Défiler",
      alt: "Vue aérienne de Bordighera et de sa côte",
    },
    whatsapp: {
      label: "Écrivez-nous sur WhatsApp",
      msg: "Bonjour, je souhaiterais des informations sur les appartements Dimore del Sole à Bordighera.",
      call: "Appeler",
    },
    video: { label: "La vidéo", title: "La résidence vue par drone" },
    manifesto: {
      label: "Pourquoi Dimore del Sole",
      h2a: "Neufs, en classe A, avec jardins, terrasses et garages : ",
      h2em: "la vraie valeur",
      h2b: " sur la Riviera des Fleurs.",
      chapters: [
        { n: "01", t: "Neuf et classe A : zéro travaux, factures légères", d: "Construction tout juste achevée : aucune rénovation, aucune surprise. Grès cérame, menuiseries haut de gamme et installation photovoltaïque commune : une efficacité qui se ressent chaque mois, sur les factures comme dans le confort." },
        { n: "02", t: "L'extérieur est à vous : jardins, terrasses et piscine", d: "Jardins privés jusqu'à 300 m², terrasses panoramiques et piscine commune entourée de verdure. À Bordighera, on vit dehors douze mois par an, sous l'un des climats les plus doux d'Italie." },
        { n: "03", t: "Les 8 premiers appartements livrables immédiatement", d: "Le Bâtiment A est achevé : huit appartements disponibles tout de suite, sans attente de chantier. Garage privé pré-équipé pour la recharge électrique et caves, achetables séparément." },
        { n: "04", t: "Un investissement durable : la Riviera des Fleurs", d: "Une construction neuve dans l'une des localités les plus recherchées de Ligurie, à quelques minutes de la mer, de la gare et de la France : une valeur appelée à croître dans le temps." },
      ],
    },
    apartments: {
      label: "Les Appartements",
      h2a: "Des solutions conçues pour ",
      h2em: "chaque exigence",
      desc: "Deux-pièces, trois-pièces et attique avec jardins privés ou grandes terrasses, dans le Bâtiment A qui vient d'être achevé et est livrable immédiatement.",
      rooms: "Pièces",
      surface: "Surface commerciale",
      outdoor: "Espace extérieur",
      price: "Prix",
      from: "à partir de",
      plan: "Plan",
      view: "Photo",
      sqUnit: "m²",
      items: {
        bilocale: { nome: "2 Pièces", esterno: "Balcon de 11 m²" },
        "bilocale-cucina": { nome: "2 Pièces + cuisine", esterno: "Jardin de 215 m²", localiLabel: "2 + cuisine" },
        trilocale: { nome: "3 Pièces", esterno: "Jardin de 300 m²" },
        attico: { nome: "Attique", esterno: "Terrasse panoramique" },
      },
      extras: {
        label: "En option, achetables séparément",
        boxTitle: "Garages",
        boxDesc: "Privés, pré-équipés pour la recharge des véhicules électriques.",
        cantinaTitle: "Caves",
        cantinaDesc: "Espaces pratiques supplémentaires, parfaits comme rangement ou cave à vin.",
      },
      ctaTitle: "Envie de les voir en vrai ? Nous vous accompagnons.",
    },
    gallery: {
      label: "Galerie",
      h2a: "La qualité de construction, des fondations ",
      h2em: "aux finitions",
      captions: ["Façades", "Espace nuit", "Cuisine et séjour", "La piscine", "La résidence vue du ciel"],
    },
    location: {
      label: "L'Environnement",
      h2a: "Entre la mer, la nature ",
      h2em: "et les services",
      p: "Dimore del Sole se situe entre la Via Mameli et la Via Pasteur, à Bordighera : un emplacement stratégique et préservé, entouré de verdure, à quelques minutes du centre, du bord de mer et de la France. À 100 mètres, le Piatti Tennis Center ; le point de départ idéal vers Sanremo, la Côte d'Azur et Monaco.",
      distLabel: "Distances",
      distances: [["Promenade Lungomare Argentina", "2,5 km"], ["Gare de Bordighera", "3 km"], ["Gare de Vintimille", "6 km"], ["Sanremo", "12 km"], ["Monte-Carlo", "25 km"], ["Aéroport de Nice", "54 km"]],
      imgAlt: "La promenade du Lungomare Argentina à Bordighera",
    },
    contact: {
      label: "Réservez votre visite",
      h2a: "Venez découvrir ",
      h2em: "Dimore del Sole",
      h2b: " en personne",
      p: "Remplissez le formulaire pour recevoir la brochure, les plans et fixer un rendez-vous. Vous serez recontacté sous 24 heures.",
      orari: "Sur rendez-vous, tous les jours",
      nome: "Prénom", cognome: "Nom", email: "Email", telefono: "Téléphone",
      tipologia: "Type de bien recherché",
      tipologie: ["2 Pièces", "2 Pièces + cuisine", "3 Pièces", "Attique", "Je ne sais pas encore"],
      messaggio: "Message (facultatif)",
      privacy: "J'ai lu la politique de confidentialité et j'accepte le traitement de mes données afin d'être recontacté. *",
      privacyLink: "Lire la politique",
      submit: "Envoyer la demande",
      sending: "Envoi en cours…",
      success: "Demande envoyée. Nous vous recontacterons sous 24 heures.",
    },
    footer: {
      tagline: "Résidence à Bordighera",
      privacy: "Politique de confidentialité",
      cookie: "Politique de cookies",
      admin: "Espace réservé",
      rights: "© 2026 Dimore del Sole — Bordighera (IM). Tous droits réservés.",
      disclaimer: "Images et rendus à titre purement illustratif. Photos de Bordighera : Wikimedia Commons (CC BY-SA).",
    },
    cookieBanner: {
      title: "Cookies",
      text: "Nous utilisons des cookies techniques et, avec votre consentement, des cookies de mesure et de publicité (Google) pour évaluer l'efficacité de nos campagnes.",
      short: "Nous utilisons des cookies techniques et, avec votre consentement, de mesure et de publicité.",
      accept: "Accepter",
      necessary: "Nécessaires uniquement",
      more: "Politique de cookies",
    },
    policies: {
      privacy: {
        title: "Politique de confidentialité",
        body: [
          "Responsable du traitement : Dimore del Sole — Via Goffredo Mameli 40, 18012 Bordighera (IM), Italie. Email : info@dimoredelsole.com.",
          "Données traitées et finalités : les données saisies dans le formulaire de contact (prénom, nom, email, téléphone, type de bien recherché, message) sont traitées dans le seul but de répondre à votre demande d'informations et de fixer un éventuel rendez-vous.",
          "Base juridique : le traitement repose sur le consentement de la personne concernée (art. 6, par. 1, point a du Règlement UE 2016/679 — RGPD) et sur l'exécution de mesures précontractuelles prises à sa demande (art. 6, par. 1, point b).",
          "Modalités et destinataires : les données sont traitées par des moyens électroniques et ne sont ni cédées à des tiers ni utilisées à des fins de marketing. Seuls le responsable du traitement et les prestataires techniques du site (hébergement et service d'envoi d'emails), en qualité de sous-traitants, y ont accès.",
          "Conservation : les données sont conservées le temps strictement nécessaire au traitement de la demande et au maximum 24 mois après le dernier contact.",
          "Droits de la personne concernée : conformément aux art. 15 à 22 du RGPD, vous pouvez à tout moment demander l'accès, la rectification, l'effacement, la limitation et la portabilité de vos données, vous opposer au traitement et retirer votre consentement en écrivant à info@dimoredelsole.com.",
          "Réclamation : vous avez également le droit d'introduire une réclamation auprès de l'autorité de contrôle italienne, le Garante per la Protezione dei Dati Personali (www.garanteprivacy.it), ou de votre autorité nationale (en France, la CNIL).",
        ],
      },
      cookie: {
        title: "Politique de cookies",
        body: [
          "Ce site, conformément au Règlement UE 2016/679 (RGPD) et à la directive ePrivacy, utilise des cookies techniques et des outils de stockage local nécessaires à son fonctionnement — la préférence de langue (dds-lang) et l'enregistrement de votre choix concernant les cookies (dds-cookie-consent) — qui ne nécessitent pas de consentement préalable.",
          "Avec votre consentement, nous utilisons également Google Ads (gtag.js), un service tiers de mesure et de marketing fourni par Google Ireland Ltd., afin de mesurer l'efficacité de nos campagnes publicitaires. Ces cookies ne sont activés qu'après avoir cliqué sur « Accepter » dans la bannière (Google Consent Mode v2) ; si vous choisissez « Nécessaires uniquement », ils restent désactivés. Plus d'informations : policies.google.com/privacy.",
          "Vous pouvez modifier ou révoquer votre choix à tout moment en supprimant les cookies et les données des sites dans les paramètres de votre navigateur : la bannière vous sera de nouveau proposée lors de la prochaine visite.",
        ],
      },
    },
  },
  en: {
    seo: {
      title: "Dimore del Sole — New apartments for sale in Bordighera, Italian Riviera",
      description: "One and two-bedroom apartments and penthouse, energy class A, with pool and gardens in Bordighera, minutes from France. From € 250,000. Book a visit.",
    },
    nav: { progetto: "The Project", appartamenti: "Apartments", galleria: "Gallery", contesto: "The Area", contatti: "Contact" },
    headerCta: "Book a visit",
    brochure: "Download the brochure",
    brochureModal: {
      title: "Download the brochure",
      subtitle: "Leave your details to instantly download the full brochure with floor plans and prices. We'll also email it to you.",
      submit: "Download now",
      success: "Thank you! Your download is starting and we've also emailed you the brochure.",
      leadNote: "Brochure download request from the website",
    },
    hero: {
      eyebrow: "Residences in Bordighera — Italian Riviera",
      line1: "Living Bordighera,",
      line2: "between sea and serenity",
      subtitle: "New energy class A apartments with pool, private gardens and garages, in the greenery of Bordighera.",
      subtitle2: "Building A ready for delivery.",
      ctaPrimary: "Request information",
      scroll: "Scroll",
      alt: "Aerial view of Bordighera and its coastline",
    },
    whatsapp: {
      label: "Chat with us on WhatsApp",
      msg: "Hello, I would like more information about the Dimore del Sole apartments in Bordighera.",
      call: "Call",
    },
    video: { label: "The video", title: "The residence from the drone" },
    manifesto: {
      label: "Why Dimore del Sole",
      h2a: "New, class A, with gardens, terraces and garages: ",
      h2em: "real value",
      h2b: " on the Italian Riviera.",
      chapters: [
        { n: "01", t: "New and class A: no works, low bills", d: "Just-completed construction: no renovations, no surprises. Porcelain stoneware, high-end window frames and a shared photovoltaic system: efficiency you feel every month, in your bills and your comfort." },
        { n: "02", t: "The outdoors is yours: gardens, terraces and pool", d: "Private gardens up to 300 sqm, panoramic terraces and a shared pool surrounded by greenery. In Bordighera you live outdoors twelve months a year, in one of Italy's mildest climates." },
        { n: "03", t: "The first 8 apartments ready for delivery", d: "Building A is complete: eight apartments available right now, with no construction wait. Private garage pre-fitted for EV charging and cellars, available separately." },
        { n: "04", t: "A lasting investment: the Riviera dei Fiori", d: "A new build in one of Liguria's most sought-after locations, minutes from the sea, the station and France: value set to grow over time." },
      ],
    },
    apartments: {
      label: "The Apartments",
      h2a: "Living solutions designed for ",
      h2em: "every need",
      desc: "One and two-bedroom apartments and a penthouse with private gardens or large terraces, in the newly completed Building A, ready for delivery.",
      rooms: "Rooms",
      surface: "Commercial surface",
      outdoor: "Outdoor space",
      price: "Price",
      from: "from",
      plan: "Floor plan",
      view: "Photo",
      sqUnit: "sqm",
      items: {
        bilocale: { nome: "One-Bedroom", esterno: "11 sqm balcony" },
        "bilocale-cucina": { nome: "One-Bedroom + Kitchen", esterno: "215 sqm garden", localiLabel: "2 + kitchen" },
        trilocale: { nome: "Two-Bedroom", esterno: "300 sqm garden" },
        attico: { nome: "Penthouse", esterno: "Panoramic terrace" },
      },
      extras: {
        label: "Available separately",
        boxTitle: "Garages",
        boxDesc: "Private, pre-fitted for electric vehicle charging.",
        cantinaTitle: "Cellars",
        cantinaDesc: "Practical extra spaces, ideal for storage or a wine cellar.",
      },
      ctaTitle: "Want to see them in person? We'll show you around.",
    },
    gallery: {
      label: "Gallery",
      h2a: "Construction quality, from the foundations ",
      h2em: "to the finishes",
      captions: ["Facades", "Sleeping area", "Kitchen & living", "The pool", "The residence from above"],
    },
    location: {
      label: "The Area",
      h2a: "Between the sea, nature ",
      h2em: "and amenities",
      p: "Dimore del Sole rises between Via Mameli and Via Pasteur in Bordighera: a strategic, secluded location surrounded by greenery, minutes from the town centre, the seafront and France. The Piatti Tennis Center is 100 metres away; the perfect starting point for Sanremo, the French Riviera and Monte Carlo.",
      distLabel: "Distances",
      distances: [["Lungomare Argentina promenade", "2.5 km"], ["Bordighera railway station", "3 km"], ["Ventimiglia railway station", "6 km"], ["Sanremo", "12 km"], ["Monte Carlo", "25 km"], ["Nice Airport", "54 km"]],
      imgAlt: "The Lungomare Argentina promenade in Bordighera",
    },
    contact: {
      label: "Book your visit",
      h2a: "Come and discover ",
      h2em: "Dimore del Sole",
      h2b: " in person",
      p: "Fill in the form to receive the brochure and floor plans, and to arrange an appointment. We will get back to you within 24 hours.",
      orari: "By appointment, every day",
      nome: "First name", cognome: "Last name", email: "Email", telefono: "Phone",
      tipologia: "Type of property",
      tipologie: ["One-Bedroom", "One-Bedroom + Kitchen", "Two-Bedroom", "Penthouse", "Not sure yet"],
      messaggio: "Message (optional)",
      privacy: "I have read the privacy policy and consent to the processing of my data in order to be contacted. *",
      privacyLink: "Read the policy",
      submit: "Send request",
      sending: "Sending…",
      success: "Request sent. We will contact you within 24 hours.",
    },
    footer: {
      tagline: "Residences in Bordighera",
      privacy: "Privacy Policy",
      cookie: "Cookie Policy",
      admin: "Reserved area",
      rights: "© 2026 Dimore del Sole — Bordighera (IM), Italy. All rights reserved.",
      disclaimer: "Images and renderings for illustrative purposes only. Bordighera photos: Wikimedia Commons (CC BY-SA).",
    },
    cookieBanner: {
      title: "Cookies",
      text: "We use technical cookies and, with your consent, measurement and advertising cookies (Google) to understand the effectiveness of our campaigns.",
      short: "We use technical cookies and, with your consent, measurement and advertising cookies.",
      accept: "Accept",
      necessary: "Necessary only",
      more: "Cookie Policy",
    },
    policies: {
      privacy: {
        title: "Privacy Policy",
        body: [
          "Data controller: Dimore del Sole — Via Goffredo Mameli 40, 18012 Bordighera (IM), Italy. Email: info@dimoredelsole.com.",
          "Data processed and purposes: the data entered in the contact form (first name, last name, email, phone, type of property, message) are processed solely to answer your enquiry and arrange a possible appointment.",
          "Legal basis: processing is based on the data subject's consent (art. 6(1)(a) of EU Regulation 2016/679 — GDPR) and on pre-contractual measures taken at the data subject's request (art. 6(1)(b)).",
          "Methods and recipients: data are processed electronically and are neither shared with third parties nor used for marketing. Only the controller and the site's technical providers (hosting and email service), acting as processors, may access them.",
          "Retention: data are kept only as long as strictly necessary to handle the enquiry and in any case no longer than 24 months after the last contact.",
          "Your rights: under articles 15-22 of the GDPR you may at any time request access, rectification, erasure, restriction and portability of your data, object to processing and withdraw your consent by writing to info@dimoredelsole.com.",
          "Complaints: you also have the right to lodge a complaint with the Italian supervisory authority, the Garante per la Protezione dei Dati Personali (www.garanteprivacy.it), or with your national authority.",
        ],
      },
      cookie: {
        title: "Cookie Policy",
        body: [
          "In compliance with EU Regulation 2016/679 (GDPR) and the ePrivacy directive, this site uses technical cookies and local storage required for it to work — the language preference (dds-lang) and the record of your cookie choice (dds-cookie-consent) — which do not require prior consent.",
          "With your consent, we also use Google Ads (gtag.js), a third-party measurement and marketing service provided by Google Ireland Ltd., to measure the effectiveness of our advertising campaigns. These cookies are only activated after you click \"Accept\" in the banner (Google Consent Mode v2); if you choose \"Necessary only\", they remain disabled. More information: policies.google.com/privacy.",
          "You can change or withdraw your choice at any time by clearing cookies and site data in your browser settings: the banner will be shown again on your next visit.",
        ],
      },
    },
  },
};

const OG_LOCALES = { it: "it_IT", fr: "fr_FR", en: "en_GB" };

const LangContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem("dds-lang");
    return STRINGS[saved] ? saved : "it";
  });
  useEffect(() => {
    localStorage.setItem("dds-lang", lang);
    document.documentElement.lang = lang;
    const s = STRINGS[lang].seo;
    document.title = s.title;
    document.querySelector('meta[name="description"]')?.setAttribute("content", s.description);
    document.querySelector('meta[property="og:title"]')?.setAttribute("content", s.title);
    document.querySelector('meta[property="og:description"]')?.setAttribute("content", s.description);
    document.querySelector('meta[property="og:locale"]')?.setAttribute("content", OG_LOCALES[lang]);
  }, [lang]);
  return <LangContext.Provider value={{ lang, setLang, t: STRINGS[lang] }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
